import styled from "styled-components";
import * as React from "react";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { draftToMarkdown, markdownToDraft } from "markdown-draft-js";

type Props = {
  content: Object,
  onChange: Function,
  loading: Boolean,
  error: Object,
};

const StyledSegment = styled.div`
  min-height: 160px;
`;

export const MarkdownEdit = ({ value, onChange }: Props) => {
  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty()
  );

  React.useEffect(() => {
    setEditorState(getEditorState());
  }, []); // Run once on mount

  const getEditorState = () => {
    const content = convertFromRaw(markdownToDraft(value));
    return EditorState.createWithContent(content);
  };

  const getMarkdown = () => {
    return draftToMarkdown(convertToRaw(editorState.getCurrentContent()), {
      remarkableOptions: {
        preserveNewlines: true,
      },
    });
  };

  return (
    <StyledSegment>
      <Editor
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        editorStyle={{
          minHeight: "160px",
          borderRadius: "2px",
          border: "1px solid #f1f1f1",
          padding: "6px 5px 0",
          marginBottom: "5px",
        }}
        editorState={editorState}
        onEditorStateChange={(newEditorState) => {
          const value = draftToMarkdown(
            convertToRaw(newEditorState.getCurrentContent()),
            {
              remarkableOptions: {
                preserveNewlines: true,
              },
            }
          );
          setEditorState(newEditorState);
          onChange({ target: { value } }, { value });
        }}
        toolbar={{
          options: ["inline", "blockType", "list", "link", "emoji"],
          inline: { inDropdown: true },
          list: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
        }}
      />
    </StyledSegment>
  );
};
